import { Injectable, inject } from '@angular/core';
import { AdminBrandApiService } from '../api/services/admin-brand-api.service';
import { AdminBrandCollectionItemResponse } from '../api/responses/admin-brand-collection-item.response';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';
import { isNil, Nillable } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandSelectItemsProviderService {
  private readonly adminBrandApi = inject(AdminBrandApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchCollectionAsSelectItems<Key extends keyof AdminBrandCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<AdminBrandCollectionItemResponse[Key]>[]> {
    return this.adminBrandApi
      .fetchCollection(
        this.collectionRequestBuilder
          .sorts((builder) => [builder.ascendingFor('name').build()])
          .disablePagination()
          .build(),
        {
          skipByLoading: true,
          cacheable: true,
        }
      )
      .pipe(
        map(({ items }) =>
          items
            .filter(item => {
              if (isNil(query)) {
                return item;
              }

              return item.name.toLowerCase().includes(query);
            })
            .map((item) => new SelectItem(item.name, item[key])),
        ),
        catchError(() => of([])),
      );
  }
}
